import { render, staticRenderFns } from "./additionalInfoFooter.vue?vue&type=template&id=4fb6933e"
import script from "./additionalInfoFooter.vue?vue&type=script&lang=js"
export * from "./additionalInfoFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports